import { FlagProvider } from '@unleash/proxy-client-react';
import { createRoot } from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';

import { getConfig } from '@Helpers/featureFlags';
import Callback from './Views/Callback';
import LandingPageForm from './Views/LandingPage';
import MyQuote from './Views/MyQuote';

import ErrorBoundary from './Components/ErrorBoundry';
import ModalCloseSVG from './Components/ui/assets/close-x.svg';
import DropdownArrowSVG from './Components/ui/assets/dropdown-arrow-down.svg';

import { URL_CALLBACK, URL_MY_QUOTE, URL_PERSONAL_LINES } from './constants';

const isLocation = path => {
    // Ensure the path starts with a leading slash
    const normalizedPath = path.startsWith('/') ? path : `/${path}`;

    // Parse the current location
    const currentPath = new URL(window.location.href).pathname;

    // Compare the normalized path with the current pathname
    return currentPath === normalizedPath;
};

const router = createBrowserRouter([
    {
        path: '/my-quote',
        element: <MyQuote />,
    },
]);

const loadThis = (id, component, appName = 'tivly-crm') => {
    const start = Date.now();
    const waitForContainer = () => {
        const config = getConfig(appName);
        const container = document.getElementById(id);

        if (container) {
            const root = createRoot(container);
            root.render(
                <FlagProvider config={config}>
                    <ErrorBoundary>
                        {
                            /* Added to preload modal close button icon */ <img
                                aria-hidden
                                style={{ opacity: 0, position: 'absolute' }}
                                src={ModalCloseSVG}
                            />
                        }
                        {
                            /* Added to preload selector down arrow icon */ <img
                                aria-hidden
                                style={{ opacity: 0, position: 'absolute' }}
                                src={DropdownArrowSVG}
                            />
                        }
                        {component}
                    </ErrorBoundary>
                </FlagProvider>
            );
        } else {
            if (Date.now() - start < 800) {
                setTimeout(waitForContainer, 1);
            }
        }
    };
    setTimeout(waitForContainer, 1);
};

// Check the URL and conditionally add an element
if (isLocation(URL_MY_QUOTE)) {
    loadThis('my-quote', <RouterProvider router={router} />);
} else if (isLocation(URL_PERSONAL_LINES)) {
    loadThis('landing-form-container', <LandingPageForm />);
} else if (isLocation(URL_CALLBACK)) {
    loadThis('callback', <Callback />);
} else {
    loadThis('landing-form-container', <LandingPageForm />);
}
